import {Component, EventEmitter, Input,Output, OnInit} from '@angular/core';
import {CurrencySymbolPipe} from "../../../shared/pipes/currency-symbol.pipe";
import {OrderDetails} from "../../model/OrderDetails";
import {DecimalPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";
import {DividerModule} from "primeng/divider";

@Component({
    selector: 'app-plan-details',
    standalone: true,
    imports: [
        CurrencySymbolPipe,
        NgClass,
        NgForOf,
        NgIf,
        TranslatePipe,
        DecimalPipe,
        DividerModule
    ],
    templateUrl: './plan-details.component.html',
    styleUrl: './plan-details.component.scss'
})
export class PlanDetailsComponent implements OnInit{

    @Input() activeStep!: number;
    @Input() selectedPackage!: OrderDetails;
    @Input() isYearly!: boolean;
    @Output() buySelectedPlan = new EventEmitter();

    ngOnInit() {
    }

    nextStep() {
        this.buySelectedPlan.emit(this.selectedPackage);
    }
}
